<div *ngIf="requestState" [ngClass]="{ 'd-none': !hasData }">
    <div class="chart-container" #chartTarget style="width: 100%"></div>
</div>
